import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const CreateUseOfProceedsModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  createMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  vendorName, onVendorNameChange, vendorNameError, setVendorNameError,
  itemDetails, onItemDetailsChange, itemDetailsError, setItemDetailsError,
  amount, onAmountChange, amountError, setAmountError
}) =>
  <ModalFormUI
    context={context}
    titleLabel=''
    buttonLabel='Create'
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF name='vendorName' label='Vendor name'
      value={vendorName} onChange={onVendorNameChange} required={true}
      error={vendorNameError} setError={setVendorNameError}
    />
    <InputTextSF name='itemDetails' label='Item details'
      value={itemDetails} onChange={onItemDetailsChange} required={true}
      error={itemDetailsError} setError={setItemDetailsError}
    />
    <InputTextSF name='amount' label='Amount'
      value={amount} onChange={onAmountChange} required={true}
      error={amountError} setError={setAmountError}
    />
  </ModalFormUI>

export default CreateUseOfProceedsModalUI
